import { IDraggableSidebarItem } from "../../controls";
import { type ArsTableSidebarItemData } from "./interface";

export interface GroupingFactorSidebarItemProps {
  item: IDraggableSidebarItem<ArsTableSidebarItemData>;
  selected: boolean;
}

/**
 * Custom sidebar item renderer for grouping factors.
 *
 * @param props - Props containing the sidebar item and selection state
 * @param props.item - Sidebar item with discriminated union data for grouping factor
 * @param props.selected - Whether the item is currently selected
 * @returns Grouping factor display element
 */
export const GroupingFactorSidebarItem = ({ item, selected }: GroupingFactorSidebarItemProps) => {
  const groupingFactor = item.data.kind === "groupingFactor" ? item.data.dropItem : null;

  return (
    <div
      className={`px-2 py-1 border rounded w-100 ${selected ? "border-primary bg-primary-subtle" : ""}`}
      style={{ cursor: "grab" }}
    >
      <div className="fw-semibold">{item.label}</div>
      {groupingFactor && (
        <small className="text-muted">
          {groupingFactor.dataDriven ? "Data driven" : "Groups"} • {groupingFactor.name}
        </small>
      )}
    </div>
  );
};

GroupingFactorSidebarItem.displayName = "GroupingFactorSidebarItem";
